import { render, staticRenderFns } from "./transferenciaVideos.vue?vue&type=template&id=76be32ea&scoped=true"
import script from "./transferenciaVideos.vue?vue&type=script&lang=js"
export * from "./transferenciaVideos.vue?vue&type=script&lang=js"
import style0 from "./transferenciaVideos.vue?vue&type=style&index=0&id=76be32ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76be32ea",
  null
  
)

export default component.exports